export const getVasFinalScreenData = finalScreenData => ({
  challanDesktopDescription: finalScreenData?.challanDesktopDescription,
  challanDesktopHeading: finalScreenData?.challanDesktopHeading,
  challanKeyFeaturesDesktop: finalScreenData?.challanKeyFeaturesDesktop,
  challanKeyFeaturesMobile: finalScreenData?.challanKeyFeaturesMobile,
  challanMobileDescription: finalScreenData?.challanMobileDescription,
  challanMobileHeading: finalScreenData?.challanMobileHeading,
  carImageSrc: finalScreenData?.carImageSrc,
  mediaSrc: finalScreenData?.mediaSrc,
  bgBlurImageUrl: finalScreenData?.bgBlurImageUrl,
})
